import { ICompletedEnvelopeDocument, IEnvelopeDocument } from './envelopeDocument';

export interface IEnvelope {
  id: string;
  externalEnvelopeId: string | null;
  assigneeTypeId: string;
  assigneeTypeName: string;
  completedDocuments: ICompletedEnvelopeDocument[];
  createdBy: string;
  updatedDateUtc: string;
  status: EnvelopeStatus;
  ownerTypeId: string;
  ownerTypeName: string;
  documents: IEnvelopeDocument[];
}

export enum EnvelopeStatus {
  Pending = 'Pending',
  NotSigned = 'NotSigned',
  AssigneeAssigned = 'AssigneeAssigned',
  OwnerAssigned = 'OwnerAssigned',
  WaitingForOthers = 'WaitingForOthers',
  Completed = 'Completed'
}

export const EnvelopeStatusDescription = new Map<EnvelopeStatus, string>([
  [EnvelopeStatus.Pending, 'Pending'],
  [EnvelopeStatus.NotSigned, 'Not Signed'],
  [EnvelopeStatus.AssigneeAssigned, 'Assignee Assigned'],
  [EnvelopeStatus.OwnerAssigned, 'Owner Assigned'],
  [EnvelopeStatus.WaitingForOthers, 'Waiting For Others'],
  [EnvelopeStatus.Completed, 'Completed']
]);
